import { Location } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core'

import { SearchResponseType } from '../../../services/global-search.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { FindTrackType } from '../../../types/filter.type'

@Component({
  selector: 'bmcore-search-tag-input',
  templateUrl: './bmcore-search-tag-input.component.html',
  styleUrls: ['./bmcore-search-tag-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSearchTagInputComponent implements OnInit {
  @Input() searchTagTitle: string
  @Input() tags: SearchResponseType[] = []
  @Input() isTagDropdown: boolean

  @Output() changeTagsValueEvent = new EventEmitter<FindTrackType>()
  @Output() findTagsEvent = new EventEmitter<SearchResponseType>()
  @Output() showBeatmakerDropdownEvent = new EventEmitter<boolean>()
  @Output() showTagDropdownEvent = new EventEmitter<boolean>()
  @Output() clearSearchTagTileEvent = new EventEmitter()

  lg: LgType

  constructor(
    private i18nService: I18nService,
    private eRef: ElementRef,
    private location: Location
  ) {
    this.lg = this.i18nService.getLanguageForPage()
  }

  ngOnInit(): void {}

  // close search dropdown when click outside
  // https://stackoverflow.com/a/40107009
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      if (event.target.nodeName === 'DIV') {
        if (this.isTagDropdown) {
          this.clearTagsField()
        }
      }
    }
  }

  changeTagsValue(searchData: FindTrackType) {
    this.changeTagsValueEvent.next({ search: searchData.search, searchType: searchData.searchType })
  }

  findTracksByTag(id: number, value: string) {
    this.showTagDropdownEvent.emit(false)
    this.findTagsEvent.emit({ id, value })
  }

  closeBeatmakerDropdown() {
    this.showBeatmakerDropdownEvent.emit(false)
  }

  clearTagsField() {
    const locationPath = this.location.path()

    if (locationPath.includes('tag')) {
      this.closeBeatmakerDropdown()
      this.changeTagsValue({ search: '', searchType: 'tag' })
    } else {
      this.showTagDropdownEvent.emit(false)
      this.clearSearchTagTileEvent.emit()
    }
  }
}
